import React from 'react';

export const CommentsUnderIcon = (props) => {
  return (
    <svg
      fill='none'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      viewBox='0 0 24 24'
      height='1em'
      width='1em'
      {...props}
    >
      <path d='M9 10l-5 5 5 5' />
      <path d='M20 4v7a4 4 0 01-4 4H4' />
    </svg>
  );
};
